import { Component, OnInit } from "@angular/core";
import { User } from "../interfaces/user";
import { AuthenticationService } from "../services/authentication.service";
import { UserService } from "../services/user.service";
import { MenuService } from "../services/menu.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
})
export class MenuComponent implements OnInit {
  user: User;
  items: object[];

  constructor(
    private authService: AuthenticationService,
    private userService: UserService,
    private menuService: MenuService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authService.getStatus().subscribe((status) => {
      if (status != null) {
        this.userService
          .getUserById(status.uid)
          .valueChanges()
          .subscribe(
            (data: User) => {
              this.user = data;
              if (this.user != null) {
                this.menuService
                  .getMenuByUser(this.user.rol)
                  .valueChanges()
                  .subscribe(
                    (data2) => {
                      this.items = [];
                      this.items = Object.values(data2);
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    });
  }
  logout(uid) {
    this.authService
      .logout()
      .then(() => {
        const active = {
          uid: uid,
          value: 0,
        };
        this.userService
          .setActive(active)
          .then(() => {
            this.router.navigate(["login"]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
